import { FieldValues, FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DetailsPopUpContent from 'shared/components/details-pop-up-content/details-pop-up-content';
import PopUp from 'shared/components/pop-up/pop-up';

import { useGatewaysContextProvider } from 'features/gateway/context/gateway-provider';
import Gateway from 'features/gateway/domain/models/gateway';
import { GatewayStatus } from 'features/gateway/domain/models/gateway-status';
import { GatewayType } from 'features/gateway/domain/models/gateway-type';
import GatewayDetailsPopupHeader from 'features/gateway/views/gateway-details/gateway-details-popup-header';
import GatewayInformation from 'features/gateway/views/gateway-details/gateway-information.component';
import GatewaySettings from 'features/gateway/views/gateway-details/gateway-settings/gateway-settings';

const GatewayDetailsPopup = () => {
  const { t } = useTranslation('gateway');

  const { gatewayDetailsHook } = useGatewaysContextProvider();

  const submitForm = (fieldValues: FieldValues) => {
    const gateway: Gateway = {
      id: gatewayDetailsHook.currentSelectedGateway?.id,
      type: fieldValues.type,
      name: fieldValues.name?.trim(),
      ipAddress: fieldValues.ipAddress?.trim(),
      cidr: fieldValues.cidr,
      note: fieldValues.note?.trim(),
      organisationUnitId: fieldValues.organisationUnitId,
      lastCommunicationDate: gatewayDetailsHook.currentSelectedGateway?.lastCommunicationDate,
      shouldCreateDevicesAutomatically: fieldValues.shouldCreateDevicesAutomatically,
      shouldMonitorMediaserver: fieldValues.shouldMonitorMediaserver,
      offlinePortalPassword: fieldValues.offlinePortalPassword,
      offlinePortalUsername: fieldValues.offlinePortalUsername,
      kadexIpAddress: fieldValues.kadexIpAddress,
      kadexUsername: fieldValues.kadexUsername,
      kadexPassword: fieldValues.kadexPassword,
      childGateways: fieldValues.childGateways,
      status: GatewayStatus.notMonitored,
      isAlarmmonitorEnabled: fieldValues.isAlarmmonitorEnabled,
      isSonevoApiEnabled: fieldValues.isSonevoApiEnabled,
      isAudioEnabled: fieldValues.isAudioEnabled,
      isMediaserverEnabled: fieldValues.isMediaserverEnabled,
      isKadexApiEnabled: fieldValues.isKadexApiEnabled,
      isIS32ApiEnabled: fieldValues.isIS32ApiEnabled,
      isIPUnitApiEnabled: fieldValues.isIPUnitApiEnabled,
      isDomipApiEnabled: fieldValues.isDomipApiEnabled,
      isRetryMechanismEnabled: fieldValues.isRetryMechanismEnabled,
      isWanderingPreventionApiEnabled: fieldValues.isWanderingPreventionApiEnabled,
      isIntercomModuleEnabled: fieldValues.isIntercomModuleEnabled,
      canBeDeleted: gatewayDetailsHook.currentSelectedGateway?.canBeDeleted ?? true,
      canChangeOrganisationUnit: gatewayDetailsHook.currentSelectedGateway?.canChangeOrganisationUnit ?? true,
    };

    gatewayDetailsHook.submitGateway(gateway);
  };

  const popUpStyle = {
    style: {
      height: '960px',
      width: '1227px',
      maxWidth: '1227px',
      paddingBottom: '0px',
    },
  };

  return (
    <>
      <Dialog
        open={gatewayDetailsHook.isDetailsOpen}
        onClose={() => gatewayDetailsHook.closeDetails(gatewayDetailsHook.form.formState.isDirty)}
        slotProps={{
          paper: popUpStyle,
        }}
      >
        <FormProvider {...gatewayDetailsHook.form}>
          <DetailsPopUpContent
            onSubmit={gatewayDetailsHook.form.handleSubmit(submitForm)}
            leftContent={<GatewayInformation />}
            rightContent={<GatewaySettings />}
            header={<GatewayDetailsPopupHeader />}
          />
        </FormProvider>
      </Dialog>
      <PopUp
        isOpen={gatewayDetailsHook.isIpAddressPopupOpen}
        title={t('details.ipAddressPopup.title')}
        body={
          gatewayDetailsHook.currentSelectedGateway?.type === GatewayType.IoTEdgeMediaServerGatewayCluster
            ? t('details.ipAddressPopup.bodyTextShort')
            : t('details.ipAddressPopup.bodyText')
        }
        primaryButtonText={t('details.ipAddressPopup.confirmButton')}
        secondaryButtonText={t('details.ipAddressPopup.cancelButton')}
        handleOnClose={gatewayDetailsHook.closeIpAddressPopup}
        secondaryButtonAction={gatewayDetailsHook.closeIpAddressPopup}
        primaryButtonAction={() => gatewayDetailsHook.ipAddressConfirmationAction?.()}
      />
    </>
  );
};

export default GatewayDetailsPopup;
